import React from 'react';
import { Path } from 'react-konva';

const symbol_code = 'M69.61,36.85L59.44,4.81c-0.21-0.64-0.49-1.26-0.9-1.85c-2.22-3.15-6.59-3.9-9.75-1.69L2.97,33.33c-3.16,2.21-3.92,6.56-1.7,9.71C2.62,44.96,4.79,46,6.99,46H63c3.87,0,7-3.12,7-6.97C70,38.26,69.84,37.54,69.61,36.85zM46.93,16.06l-28,19.51c-0.31,0.21-0.66,0.32-1,0.32c-0.55,0-1.09-0.26-1.43-0.75c-0.55-0.79-0.36-1.87,0.43-2.43l28-19.51c0.79-0.55,1.88-0.36,2.44,0.43C47.91,14.43,47.72,15.51,46.93,16.06z';

export const EasypromosLogoSymbol = (props) => {
	if(props.in_konva != undefined && props.in_konva) {
		return (
			<Path data={symbol_code} fill={props?.fill || '#FFFFFF'} />
		);
	}

	return (
		<svg width="70px" height="46px" viewBox="0 0 70 46">
			<path d={symbol_code} />
		</svg>
	)
}

const EasypromosLogo = (props) => {
	const data = [
		symbol_code,

		// e
		'M90.66,25C84.38,25,80,29.7,80,35.8c0,6.19,4.74,10.8,11.2,10.8c3.84,0,6.28-1.17,7.77-2.3c0.36-0.32,0.41-0.68,0.18-1.08l-1.17-1.94c-0.23-0.45-0.59-0.5-0.99-0.18c-1.22,0.81-2.8,1.72-5.29,1.72c-3.89,0-6.69-2.39-7.23-5.69h15.41c0.45,0,0.72-0.27,0.77-0.77v-0.72C100.65,29.38,96.63,25,90.66,25z M96.36,33.9H84.52c0.63-3.21,3.03-5.24,6.28-5.24c2.94,0,5.24,2.08,5.56,5.15C96.36,33.81,96.36,33.9,96.36,33.9z',

		// a
		'M124.81,25.41h-2.58c-0.45,0-0.72,0.27-0.77,0.72l-0.14,2.03c-1.58-1.81-4.07-3.16-7.41-3.16c-5.69,0-10.08,4.61-10.08,10.8s4.34,10.8,10.03,10.8c3.52,0,6.01-1.58,7.59-3.7l0.14,2.58c0,0.45,0.32,0.72,0.72,0.72h2.48c0.5,0,0.77-0.27,0.77-0.77V26.17C125.57,25.68,125.3,25.41,124.81,25.41z M114.77,42.47c-3.57,0-6.42-2.85-6.42-6.69s2.85-6.69,6.42-6.69c3.89,0,6.46,2.85,6.51,6.69C121.28,39.64,118.66,42.47,114.77,42.47z',

		// s
		'M139.34,33.72c-3.52-0.86-4.79-1.4-4.79-2.76c0-1.54,1.4-2.21,3.34-2.21c2.17,0,3.89,0.54,5.65,1.49c0.45,0.27,0.81,0.18,1.04-0.23l1.13-2.08c0.27-0.45,0.18-0.81-0.23-1.04c-1.76-1.04-4.25-1.85-7.36-1.85c-4.88,0-8.13,2.39-8.13,6.14c0,3.7,3.34,5.29,7.41,6.28c3.3,0.81,4.38,1.54,4.38,2.98c0,1.58-1.4,2.44-3.7,2.44c-2.62,0-4.79-0.81-6.37-1.85c-0.41-0.27-0.77-0.18-1.04,0.23l-1.22,2.12c-0.23,0.45-0.18,0.81,0.27,1.04c2.17,1.31,4.83,2.17,8.09,2.17c5.29,0,8.54-2.58,8.54-6.37C146.34,36.34,143.72,34.85,139.34,33.72z',

		// y
		'M169.43,25.41h-3.16c-0.41,0-0.72,0.18-0.86,0.59l-6.01,15.04L153.3,26c-0.14-0.41-0.45-0.59-0.86-0.59h-3.48c-0.54,0-0.77,0.36-0.54,0.9L157,46.18l-3.21,7.95c-0.23,0.5,0.05,0.86,0.59,0.86h2.94c0.41,0,0.72-0.23,0.86-0.59l4.11-9.8l7.68-18.29C170.2,25.77,169.97,25.41,169.43,25.41z',

		// p
		'M185.52,25c-3.48,0-5.96,1.49-7.59,3.57l-0.14-2.44c0-0.45-0.32-0.72-0.77-0.72h-2.35c-0.45,0-0.77,0.27-0.77,0.77v28.05c0,0.5,0.32,0.77,0.77,0.77h2.94c0.45,0,0.77-0.27,0.77-0.77V43.2c1.54,1.9,3.98,3.39,7.23,3.39c5.74,0,10.03-4.61,10.03-10.8S191.21,25,185.52,25z M184.71,42.47c-3.89,0-6.51-2.85-6.51-6.69c0-3.89,2.62-6.69,6.51-6.69c3.57,0,6.42,2.85,6.42,6.69C191.12,39.64,188.28,42.47,184.71,42.47z',

		// r
		'M211.88,25.05c-0.32-0.05-0.68-0.05-1-0.05c-3.7,0-6.19,2.03-7.05,4.47l-0.14-3.34c0-0.45-0.32-0.72-0.77-0.72h-2.35c-0.45,0-0.77,0.27-0.77,0.77v19.24c0,0.5,0.32,0.77,0.77,0.77h2.98c0.5,0,0.77-0.27,0.77-0.77v-10.3c0.05-2.94,2.03-5.83,5.92-5.83c0.45,0,0.86,0.05,1.17,0.14c0.5,0.09,0.81-0.09,0.86-0.63l0.27-2.89C212.6,25.45,212.37,25.09,211.88,25.05z',

		// o
		'M225.26,25.05c-6.1,0-11.07,4.61-11.07,10.8c0,6.14,4.97,10.75,11.07,10.75c6.05,0,11.02-4.61,11.02-10.75C236.28,29.65,231.31,25.05,225.26,25.05z M225.26,42.47c-3.61,0-6.51-2.94-6.51-6.64c0-3.8,2.89-6.73,6.51-6.73c3.57,0,6.46,2.94,6.46,6.73C231.72,39.55,228.83,42.47,225.26,42.47z',

		// m
		'M265.4,25c-3.3,0-5.87,1.94-7.09,4.2c-1.45-2.58-4.11-4.2-7.59-4.2c-3.25,0-5.87,1.85-7.05,4.11l-0.14-2.98c-0.05-0.45-0.36-0.72-0.81-0.72h-1.9c-0.45,0-0.77,0.27-0.77,0.77v19.24c0,0.5,0.32,0.77,0.77,0.77h2.98c0.5,0,0.77-0.27,0.77-0.77l0.05-11.11c0.27-2.71,2.12-5.24,5.38-5.24c3.07,0,5.06,2.44,5.06,6.19v10.17c0,0.5,0.27,0.77,0.72,0.77h3.03c0.45,0,0.77-0.27,0.77-0.77v-10.3c0-3.34,2.08-6.05,5.38-6.05c3.16,0,5.06,2.44,5.06,6.19v10.17c0,0.5,0.27,0.77,0.72,0.77h3.03c0.45,0,0.72-0.27,0.72-0.77V34.67C274.48,28.84,270.82,25,265.4,25z',

		// o
		'M288.74,25.05c-6.1,0-11.07,4.61-11.07,10.8c0,6.14,4.97,10.75,11.07,10.75c6.05,0,11.02-4.61,11.02-10.75C299.77,29.65,294.8,25.05,288.74,25.05z M288.74,42.47c-3.61,0-6.51-2.94-6.51-6.64c0-3.8,2.89-6.73,6.51-6.73c3.57,0,6.46,2.94,6.46,6.73C295.2,39.55,292.31,42.47,288.74,42.47z',

		// s
		'M312.99,33.72c-3.52-0.86-4.79-1.4-4.79-2.76c0-1.54,1.4-2.21,3.34-2.21c2.17,0,3.89,0.54,5.65,1.49c0.45,0.27,0.81,0.18,1.04-0.23l1.13-2.08c0.27-0.45,0.18-0.81-0.23-1.04c-1.76-1.04-4.25-1.85-7.36-1.85c-4.88,0-8.13,2.39-8.13,6.14c0,3.7,3.34,5.29,7.41,6.28c3.3,0.81,4.38,1.54,4.38,2.98c0,1.58-1.4,2.44-3.7,2.44c-2.62,0-4.79-0.81-6.37-1.85c-0.41-0.27-0.77-0.18-1.04,0.23l-1.22,2.12c-0.23,0.45-0.18,0.81,0.27,1.04c2.17,1.31,4.83,2.17,8.09,2.17c5.29,0,8.54-2.58,8.54-6.37C319.99,36.34,317.37,34.85,312.99,33.72z',
	];
	
	if(props.in_konva != undefined && props.in_konva) {
		return (
			<>
				{data.map((path, p) => {
					return (
						<Path key={p} data={path} fill={props?.fill || '#FFFFFF'} />
					)
				})}
			</>
		);
	}

	return (
		<svg width="320px" height="55px" viewBox="0 0 320 55">
			{data.map((path, p) => {
				return (
					<path key={p} d={path} />
				)
			})}
		</svg>
	)
}

export default EasypromosLogo;